import PersonOutlineIcon from '@mui/icons-material/PersonOutline'

import { PillSelect, type PillOption } from './PillSelect'
import { type Pharmacist } from '@/features/auth/types/pharmacy'

interface Props {
  pharmacists: Pharmacist[]
  value: string
  onChange: (id: string) => void
  disabled?: boolean
}

// 担当薬剤師の選択 pill (= 録音モードと同じ PillSelect プリミティブ). 録音開始時にどの
// 薬剤師の記録かを選ぶ. 選択肢が 1 名以下なら呼び出し側で非表示にする (= 選ぶ余地が
// ないため). 選択値は useSessionPharmacist が localStorage に永続化する.
export const PharmacistMenu = ({
  pharmacists,
  value,
  onChange,
  disabled,
}: Props) => {
  const options: PillOption<string>[] = pharmacists.map((p) => ({
    value: p.id,
    label: p.display_name,
  }))
  return (
    <PillSelect
      value={value}
      options={options}
      onChange={onChange}
      ariaLabel="担当薬剤師"
      icon={<PersonOutlineIcon />}
      disabled={disabled}
    />
  )
}
